// "02:30 PM" or "14:30" to "14:30" for time inputs, the API stores times as "hh:mm tt"
const formatTimeTo24Hour = (value?: string, emptyValue = ""): string => {
  if (!value) {
    return emptyValue;
  }

  if (value.includes("AM") || value.includes("PM")) {
    const [timePart, modifier] = value.split(" ");
    const [hoursRaw, minutesRaw] = timePart.split(":");
    let hours = parseInt(hoursRaw, 10);
    if (modifier === "PM" && hours < 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }
    return `${String(hours).padStart(2, "0")}:${(minutesRaw ?? "00").slice(0, 2)}`;
  }

  const [hours = "00", minutes = "00"] = value.split(":");
  return `${hours.padStart(2, "0").slice(0, 2)}:${minutes.padStart(2, "0").slice(0, 2)}`;
};

export default formatTimeTo24Hour;
